module.exports = __webpack_public_path__ + "img/cool.9cd65b2.gif?v=1764327952164";